import { BlockModel } from "../models/MgarantorModel";
import { OPD_CONST } from "../properties/opd-static-properties";
export class BlockService {
  constructor(
    
  ) {}

  getBlockModel(blocker: any): BlockModel {
    try {
      let list: any = [];
      blocker.forEach((element) => {
        let reason = "",
          remarks = "",
          blockingBy = "",
          blockingDate: Date;
        if (element.isBlocked) {
          let status = "";
          if (element.isBlocked) status = OPD_CONST.displayBlockStatus.blocked;
          if (element.isCTOS) status = OPD_CONST.displayBlockStatus.ctosBlocked;

          reason = element.patientBlock
            ? element.patientBlock[element.patientBlock.length - 1].reason
              ? element.patientBlock[element.patientBlock.length - 1].reason[0]
                  .display
              : ""
            : "";
          remarks = element.patientBlock
            ? element.patientBlock[element.patientBlock.length - 1].remarks
            : "";
          blockingBy = element.patientBlock
            ? element.patientBlock[element.patientBlock.length - 1].markedBy
            : "";
          let time = element.patientBlock
            ? element.patientBlock[element.patientBlock.length - 1].markedOn *
              1000
            : null;
          blockingDate = new Date(time);
          const blockModel: BlockModel = {
            MongoId: element.id,
            primaryIDdesc: element.primaryIdentifier
              ? element.primaryIdentifier.display
              : "",
            primaryId: element.primaryIdentifier
              ? element.primaryIdentifier.value
              : "",
            firstName: element.name,
            patientNameLangBase: element.patientNameLangBase || element.name,
            dob: element.birthDate ? element.birthDate : "",
            phoneNumber: element.mobileNumber
              ? element.mobileNumber.mobileNumber
              : "",
            photo: "",
            MRN: element.mrn,
            gender: element.gender ? element.gender.display : "",
            blockStatus: status,
            isBlocked: element.isBlocked,
            isCTOS: element.isCTOS,
            reason: reason,
            remarks: remarks,
            blockedBy: blockingBy,
            blockedDate: blockingDate,
            patientBlock: element.patientBlock,
          };
          list.push(blockModel);
        }
      });
      return list;
    } catch (ex) {}
  }

}
